/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import {
  RECEIVED_NASU_APPLICATIONS,
  RECEIVED_DELETE_IN_PROGRESS_APPLICATION
} from 'state/nasuApplications/nasuApplicationsActions';

export const nasuApplicationReducer = (state = {}, action) => {
  if (action.type !== RECEIVED_NASU_APPLICATIONS) {
    return state;
  }

  return action.applications;
};

export const nasuApplicationReducerv2 = (state = [], action = {}) => {
  if (action.type === RECEIVED_NASU_APPLICATIONS) {
    return action.applications;
  } else if (action.type === RECEIVED_DELETE_IN_PROGRESS_APPLICATION) {
    if (!action.applicationID) {
      return state;
    }

    return state.filter((app) => app?.applicationID !== action.applicationID);
  }
  return state;
};
